export const isProductDiscontinued = (product) => product.isDiscontinued;

export const isProductUnavailableForUS = () => false;

export const isProductUnavailable = (product) => {
  return isProductDiscontinued(product);
};

const hasAnyEffectiveAvailableVariant = ({
  variants = [],
  stockPriceVariants = [],
  shouldUseStockPriceOverride = false,
}) => {
  if (shouldUseStockPriceOverride && stockPriceVariants.length) {
    return stockPriceVariants.some((variant) => Boolean(variant?.isInStock));
  }

  if (!variants.length) {
    return false;
  }

  return variants.some((productVariant) =>
    Boolean(productVariant?.isAvailable)
  );
};

export const normalizeProductDiscontinuedState = ({
  product = {},
  stockPriceVariants = [],
  shouldUseStockPriceOverride = false,
} = {}) => {
  const originalIsDiscontinued = Boolean(product?.isDiscontinued);

  if (!originalIsDiscontinued) {
    return {
      normalizedIsDiscontinued: false,
      isDiscontinuedOverride: false,
    };
  }

  const hasAnyAvailableVariant = hasAnyEffectiveAvailableVariant({
    variants: product?.variants,
    stockPriceVariants,
    shouldUseStockPriceOverride,
  });
  const normalizedIsDiscontinued = !hasAnyAvailableVariant;

  return {
    normalizedIsDiscontinued,
    isDiscontinuedOverride: !normalizedIsDiscontinued,
  };
};
